const emptyState = {
  title: '',
  showCredits: true,
  showExit: false,
  showBack: false,
  showLogo: false,
  showSettings: false,
  showDrawer: false,
  showNotification: false
};

export const headerReducer = (state = emptyState, { type, payload }) => {
  switch (type) {
    case 'SET_TITLE':
      return {
        ...state,
        title: payload
      };

    case 'TOGGLE_CONFIGS':
      return {
        ...state,
        showCredits: payload.credits,
        showExit: payload.exit,
        showBack: payload.back,
        showLogo: payload.logo,
        showSettings: payload.settings,
        showDrawer: payload.drawer,
        showNotification: payload.notification
      };

    default:
      return state;
  }
};
